/**
 * @generated SignedSource<<a572e2652f8691172e6e37dab3ced597>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GetSuggestedClientLogoInput = {
  name?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type getSuggestedClientLogoMutation$variables = {
  input: GetSuggestedClientLogoInput;
};
export type getSuggestedClientLogoMutation$data = {
  readonly getSuggestedClientLogo: {
    readonly suggestedLogoSrc: string | null;
  } | null;
};
export type getSuggestedClientLogoMutation = {
  variables: getSuggestedClientLogoMutation$variables;
  response: getSuggestedClientLogoMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GetSuggestedClientLogoPayload",
    "kind": "LinkedField",
    "name": "getSuggestedClientLogo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "suggestedLogoSrc",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getSuggestedClientLogoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getSuggestedClientLogoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaf097bccbf94054c192798914842925",
    "id": null,
    "metadata": {},
    "name": "getSuggestedClientLogoMutation",
    "operationKind": "mutation",
    "text": "mutation getSuggestedClientLogoMutation(\n  $input: GetSuggestedClientLogoInput!\n) {\n  getSuggestedClientLogo(input: $input) {\n    suggestedLogoSrc\n  }\n}\n"
  }
};
})();

(node as any).hash = "b15bcbfe20fe3bad0fa49f10ac29f234";

export default node;
